import React, { useMemo } from "react";
import ReactFlow, { Background, Controls, ReactFlowProvider } from "react-flow-renderer";
import "react-flow-renderer/dist/style.css";
import HabitacionCanvas from "./Components/HabitacionCanvas";
import { construirNodosHabitaciones, habitacionIdDeNodo } from "./Components/nodosHabitaciones";

const nodeTypes = { habitacion: HabitacionCanvas };

//Lienzo de SOLO LECTURA del mapa de un piso del hotel. Mismo molde que LienzoMapaWms.js: aquí no se
//edita nada y el doble clic delega en `onHabitacionDoubleClick` para que la página abra el detalle.
//A diferencia del mapa de almacén no hay `edges`: un hotel no tiene grafo de circulación, solo
//cuartos colocados en el plano.
const LienzoMapaHotel = ({
  habitaciones,
  ocupacion,
  ocupacionProgramada,
  onHabitacionDoubleClick,
  onInit,
  altura,
}) => {
  const nodes = useMemo(
    () =>
      construirNodosHabitaciones({ habitaciones, ocupacion, ocupacionProgramada, editable: false }),
    [habitaciones, ocupacion, ocupacionProgramada]
  );

  const manejarDobleClick = (event, node) => {
    if (!onHabitacionDoubleClick) return;
    onHabitacionDoubleClick(habitacionIdDeNodo(node.id));
  };

  return (
    <div
      style={{
        height: altura || "70vh",
        border: "1px solid #eef0f6",
        borderRadius: 8,
        background: "#fff",
      }}
    >
      <ReactFlowProvider>
        <ReactFlow
          nodes={nodes}
          edges={[]}
          nodeTypes={nodeTypes}
          nodesDraggable={false}
          nodesConnectable={false}
          elementsSelectable={false}
          // react-flow-renderer solo activa pointer-events en un nodo si es seleccionable/arrastrable
          // o si se le pasa onClick - como aquí no queremos ninguna de las dos, se pasa un onClick
          // vacío nada más para "despertar" el nodo; si no, el doble clic nunca llega al nodo y cae
          // al lienzo, que por default hace zoom al doble clic - por eso también se desactiva abajo.
          onNodeClick={() => {}}
          onNodeDoubleClick={manejarDobleClick}
          onInit={onInit}
          panOnScroll
          zoomOnScroll
          zoomOnDoubleClick={false}
          minZoom={0.1}
          fitView
          fitViewOptions={{ padding: 0.3 }}
        >
          <Background />
          <Controls showInteractive={false} />
        </ReactFlow>
      </ReactFlowProvider>
    </div>
  );
};

export default LienzoMapaHotel;
